import { useStorage } from "reactfire";
import { textApplyVariables, useText } from "../context/TextContext";
import { ATTACHEMENT_MAX_FILE_SIZE_MB, STORAGE_PATHS } from "../utils/shared/constants";
import { toast } from "react-toastify";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { Attachement } from "../models/shared/Attachment";

export const useUploadDealAttachment = (orgId: string) => {
    const text = useText();
    const storage = useStorage();

    return async (dealId: string, file: File) => {
        const fileSizeMB = file.size / 1024 / 1024;
        if (fileSizeMB > ATTACHEMENT_MAX_FILE_SIZE_MB) {
            toast.warning(textApplyVariables(text.fileSizeTooLarge, { size: fileSizeMB.toFixed(2) }));
            return;
        }

        const path = `${STORAGE_PATHS.ORGANIZATIONS}/${orgId}/${STORAGE_PATHS.DEALS}/${dealId}/${STORAGE_PATHS.ATTACHEMENTS}/${file.name}`;

        const storageRef = ref(storage, path);
        await uploadBytes(storageRef, file);
        const downloadUrl = await getDownloadURL(storageRef);

        const newAttachment: Attachement = {
            path,
            name: file.name,
            fileType: file.type,
            createdAt: new Date(),
            url: downloadUrl
        }
        return newAttachment;
    }
}